/* global ColorTemplates */

(function ($, window, document) {
	'use strict';

var STORE = {
	template: 			{},
	categories:			[],
	colors:				[],
	selected:			{},
	view:				{
		categories: [],
		colors: []
	},
	search:				{
		keyword: ''
	},
	lastUsed:			[]
};

/**
 * ------------------------------------------------------------------------
 * API
 * ------------------------------------------------------------------------
 */
var API;
var useNewColorTemplateLogic;

$(function() {

	API = (function() {
		var sessionStorageKey = 'DUIColorPicker',

			appBaseUrl = ($('#hidApplicationUrl').val() ||
							$('input[id$="hidBaseUrl"]').val() ||
							$('input[id$="hidBaseUrl"]', parent.document).val())?.replace("http://", "https://"),

			token = $('input[id$="hidToken"]').val() ||
							$('input[id$="hidToken"]', parent.document).val(),

			projectId = $('input[id$="hdpjt"]').val() ||
							$('#hidProjectId').val() ||
							$('input[id$="hdpjt"]', parent.document).val(),

			controllerUrl = appBaseUrl + '/api/v1/project/'+ projectId +'/colortemplate/';

		function GET(options) {
			var defaults = {
				method: 'GET',
				type: 'GET',
				dataType: 'json',
				contentType: 'application/json',
				headers: {
					"authorization": "Bearer " + token + ""
				}
			};
			var settings = $.extend(true, {}, defaults, options);

			if (useNewColorTemplateLogic && appBaseUrl && token && projectId)
				return $.ajax(settings);
			else
				return $.when();
		}

		function getColorTemplate() {
			return GET({ url: controllerUrl });
		}

		function getSessionStorage() {
			return JSON.parse(window.sessionStorage.getItem(sessionStorageKey)) || {};
		}

		function setSessionStorage(sessionData) {
			window.sessionStorage.setItem(sessionStorageKey, JSON.stringify(sessionData));
		}

		//
		// public
		//
		return {
			getColorTemplate: getColorTemplate,
			getSessionStorage: getSessionStorage,
			setSessionStorage: setSessionStorage,
		}
	})();

	useNewColorTemplateLogic =  $('input[id$="hidUseNewColorTemplateLogic"]').val() === 'True' ||
								$('input[id$="hidUseNewColorTemplateLogic"]', window.parent.document).val() === 'True';

	$.fn.DUIColorPicker.useNewColorTemplateLogic = useNewColorTemplateLogic;

	load.sessionData();

	$(window).bind('load', load.colorTemplate);
});


/**
 * ------------------------------------------------------------------------
 * Project color template
 * ------------------------------------------------------------------------
 */

var load = {
	colorTemplate: function() {
		return API.getColorTemplate()
			.done(function(data) {
				var colorPickers = find.colorPickers();
				if (data === undefined) return;

				STORE.template = data;
				STORE.categories = STORE.template.categories;
				STORE.colors = STORE.template.categories
									.map(function(c) { return c.colors; })
									.reduce(function(a, b) { return a.concat(b); });
									$.fn.DUIColorPicker.useNewColorTemplateLogic = useNewColorTemplateLogic;

				// Update template colorpickers
				colorPickers.map(function(cp) {
					if (cp.is.templateSupported()) {
						var targetColor = cp.get.targetValue() || cp.get.defaultColor();
						cp.set.targetValue(targetColor.tcolor, targetColor.color);
						cp.set.targetColor(targetColor.tcolor);
					}
				});

				// Update colorselects
				$('.colorselect-target').DUIColorSelect('set.data', STORE.template);

				STORE.selected.category = find.categoryById(STORE.selected.categoryId);
				STORE.selected.color = find.colorById(STORE.selected.colorId);

				// chart creator setup
				if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART && $('#btnCCOptionalCS').length > 0) {
					Storyboard.ChartLab.Setup.createCategoriesTable(STORE.template);
				}

				$.fn.DUIColorPicker.colorTemplate = STORE.template;
			})
			.fail(function(jqXHR, textStatus, errorThrown) {
				console.error('An error occurred while processing the color template loading request.');
			});
	},

	sessionData: function() {
		var sessionData = API.getSessionStorage();
		STORE.selected = sessionData && sessionData.selected ? sessionData.selected : STORE.selected;
		STORE.lastUsed = sessionData && sessionData.lastUsed ? sessionData.lastUsed : STORE.lastUsed;
	}
};

var save = {
	sessionData: function() {
		var sessionData = {
			lastUsed:	STORE.lastUsed
		};

		API.setSessionStorage(sessionData);
	}
};

var find = {
	colorsByCategoryId: function(categoryId) {
		return STORE.colors.filter(function(c) { return c.categoryId === categoryId; });
	},

	colorById: function(colorId) {
		return STORE.colors.filter(function(c) { return c.id === colorId; })[0];
	},

	categoryById: function(categoryId) {
		return STORE.categories.filter(function(c) { return c.id === categoryId; })[0];
	},

	standardPaletteCategory: function() {
		return STORE.categories.filter(function(c) { return c.isStandardPalette === true; })[0];
	},

	colorOrId: function(colorString, colorId) {
		if (useNewColorTemplateLogic === true && colorId &&
			typeof this.colorById(colorId) === 'object')
				return colorId;
		return colorString;
	}
};


/**
 * ------------------------------------------------------------------------
 * DUI ColorPicker Control
 * ------------------------------------------------------------------------
 */

(function() {

var DUIColorPicker = function(config) {
	var query			= arguments[0],
		methodInvoked	= (typeof query == 'string'),
		queryArguments	= [].slice.call(arguments, 1),
		returnValue;

	$(this).each(function() {
		var
			settings = ( $.isPlainObject(config) )
						? $.extend(true, {}, $.fn.DUIColorPicker.settings, config)
						: $.extend({}, $.fn.DUIColorPicker.settings),

			className				= settings.className,
			selector				= settings.selector,
			templates				= settings.templates,
			element					= this,
			$target					= $(this),
			$templateTarget			= $target,
			instance				= $target.data(NAMESPACE),
			originalColor,
			$cp,
			$container,
			$dragger,
			$slider,
			$selectTemplate,
			$selectLink,
			$hex,
			$r,
			$g,
			$b,
			$h,
			$s,
			$l,

			cp;

		cp = {

			initialize: function() {
				cp.setup.data();
				cp.setup.target();
				cp.bind.targetEvents();

				instance = cp;

				$target.data(NAMESPACE, instance);
			},

			destroy: function() {
				if ($cp)
					$cp.remove();

				cp.unbind.targetEvents();

				$target
					.removeData(NAMESPACE)
					.removeClass(className.target)
					.removeAttr('style')
					.unwrap();
			},

			enable: function() {
				$target.removeAttr('disabled');
				cp.bind.targetEvents();
			},
			disable: function() {
				$target.attr('disabled', 'disabled');
				cp.unbind.targetEvents();
			},

			setup: {
				markup: function() {
					$cp 				= $(templates.markup);

					$dragger			= $cp.find(selector.dragger);
					$slider				= $cp.find(selector.slider);
					$hex				= $cp.find(selector.hex);
					$r					= $cp.find(selector.r);
					$g					= $cp.find(selector.g);
					$b					= $cp.find(selector.b);
					$h					= $cp.find(selector.h);
					$s					= $cp.find(selector.s);
					$l					= $cp.find(selector.l);

					if (cp.is.templateSupported()) {
						cp.setup.templateMarkup();
						cp.bind.templateEvents();
					} else if (cp.is.linkSupported()) {
						cp.setup.linkMarkup();
						cp.bind.linkEvents();
					} else {
						cp.setup.standardMarkup();
					}

					cp.bind.standardEvents();
					cp.spectrumDragger();
					cp.hueSlider();
				},
				standardMarkup: function() {
					$cp.find(selector.tab).parent().remove();
					$cp.find(selector.template).remove();
					$cp.find(selector.link).remove();
				},
				templateMarkup: function() {
					$cp.find(selector.link).remove();
					$cp.find(selector.linkTab).remove();
					$selectTemplate = $cp.find(selector.selectTemplate);
					$selectTemplate.DUIColorSelect();
				},
				linkMarkup: function() {
					$cp.find(selector.template).remove();
					$cp.find(selector.templateTab).remove();
					$selectLink = $cp.find(selector.selectLink);
				},
				view: {
					standard: function() {
						$cp.find(selector.standard).css('display', 'block');
						$cp.find(selector.template).css('display', 'none');
						$cp.find(selector.link).css('display', 'none');
						$cp.find(selector.templateTab).removeClass('active');
						$cp.find(selector.linkTab).removeClass('active');
						$cp.find(selector.standardTab).addClass('active');
						STORE.selected.layout = 'standard';
					},
					template: function() {
						$cp.find(selector.template).css('display', 'block');
						$cp.find(selector.standard).css('display', 'none');
						$cp.find(selector.templateTab).addClass('active');
						$cp.find(selector.standardTab).removeClass('active');
						STORE.selected.layout = 'template';
					},
					link: function() {
						$cp.find(selector.link).css('display', 'block');
						$cp.find(selector.standard).css('display', 'none');
						$cp.find(selector.linkTab).addClass('active');
						$cp.find(selector.standardTab).removeClass('active');
						STORE.selected.layout = 'link';
					},
					palette: function() {
						$cp.find(selector.palettes).css('display', 'block');
						$cp.find(selector.spectrums).css('display', 'none');
						STORE.selected.view = 'palette';
					},
					spectrum: function() {
						$cp.find(selector.palettes).css('display', 'none');
						$cp.find(selector.spectrums).css('display', 'block');
						STORE.selected.view = 'spectrum';
					}
				},
				position: function() {
					var targetOffset = $target.offset();

					var windowWidth = $(window).width() + $(window).scrollLeft();
					var windowHeight = $(window).height() + $(window).scrollTop();

					var standardTabHeight = $cp.find(selector.standard).height();

					$cp.find(selector.template).height(standardTabHeight);
					$cp.find(selector.link).height(standardTabHeight);

					var cpWidth = $cp.outerWidth();
					var cpHeight = $cp.outerHeight();

					if (!$target.is(':visible'))
						targetOffset = $target.parent().offset();

					var top = Math.min(Math.max(0, targetOffset.top - (cpHeight / 2) + 10), windowHeight - cpHeight);
					var left = windowWidth - targetOffset.left > cpWidth + 30 ? targetOffset.left + 30 : targetOffset.left - cpWidth - 10;

					$cp.find('.colorselect-category-menu').height(standardTabHeight - 45);

					if (cp.is.linkSupported())
						$cp.find('.colorselect-color-menu').height(standardTabHeight - 85 - 100);
					else
						$cp.find('.colorselect-color-menu').height(standardTabHeight - 85);

					if ($('html').hasClass('DUISetup-lock')) {
						top = Math.max(top, $(window).scrollTop());
					}

					$cp.css({
						top:	top,
						left:	left
					});
				},
				data: function() {
					// Set currently selected tamplate as a colorpicker data source
					if (cp.is.linkSupported()) {
						STORE.template = 	ColorTemplates.STORE.selected.template;
						STORE.categories = 	ColorTemplates.STORE.selected.template.categories;
						STORE.colors = 		ColorTemplates.STORE.selected.colors;
					}
				},
				target: function() {
					var targetColor, color, tcolor;

					// Template color GUID stored in hidden input field
					if ($target.next(selector.templateTarget).length > 0)
						$templateTarget = $target.next(selector.templateTarget).css('display', 'none');

					$target
						.addClass(className.target)
						.removeAttr('data-missing-template-id')
						.wrap(templates.container);

					$container = $target.parent();

					if (settings.selected.templateColorId && cp.is.templateSupported()) {
						// Selected color GUID set in settings object

						color = find.colorById(settings.selected.templateColorId);

						if (color) {
							tcolor = tinycolor({ r: color.r, g: color.g, b: color.b, a: color.a });
							targetColor = {tcolor: tcolor, color: color};
							cp.set.targetValue(tcolor, color);
						} else {
							$target.attr('data-missing-template-id', settings.selected.templateColorId);

							tcolor = tinycolor(settings.selected.colorString);

							if (tcolor.isValid() === true) {
								targetColor = {tcolor: tcolor};
								cp.set.targetValue(tcolor);
							}
						}
					} else if (settings.selected.colorString) {
						// Selected color string set in settings object

						tcolor = tinycolor(settings.selected.colorString);

						if (tcolor.isValid() === true) {
							targetColor = {tcolor: tcolor};
							cp.set.targetValue(tcolor);
						}
					}

					targetColor = cp.get.targetValue() || cp.get.defaultColor();

					$container.toggleClass(className.template, typeof targetColor.color === 'object');
					cp.set.targetColor(targetColor.tcolor, this);
				},

				adjustmentGuide: function() {
					var adjustment = $cp.find(selector.adjustment).val();
					var adjustmentGuides = {
						h: '-360 to 360',
						s: '-100 to 100',
						l: '-100 to 100'
					};

					if (typeof adjustmentGuides[adjustment] === 'string')
						$cp.find(selector.adjustmentGuide).text(adjustmentGuides[adjustment]);
					else
						$cp.find(selector.adjustmentGuide).text('');
				}
			},

			is: {
				alreadySetup: function() {
					return !!$cp;
				},
				templateSupported: function() {
					return useNewColorTemplateLogic && settings.layout === 'template';
				},
				linkSupported: function() {
					return typeof ColorTemplates === 'object' &&
							ColorTemplates.STORE && ColorTemplates.STORE.selected.template &&
							settings.layout === 'link';
				},
				active: function() {
					return $target.hasClass(className.active);
				},
				anyActive: function() {
					return $(selector.target + '.' + className.active).length > 0;
				},
				disabled: function() {
					return $target.is(':disabled');
				},
				transparent: function(tcolor) {
					return tcolor.getOriginalInput() === 'transparent' ||
							tcolor.getAlpha() === 0 ||
							tcolor.getAlpha() === 0.01 ||
							tcolor.getAlpha() === 0.001;
				}
			},

			get: {
				targetValue: function() {
					var targetValue = $target.val(),
						templateTargetValue = $templateTarget.val(),
						color,
						tcolor,
						lcolor;

					// Get selected template color from colorpicker input field GUID value
					if (cp.is.templateSupported() && STORE.colors.length > 0) {
						color = find.colorById(targetValue) || find.colorById(templateTargetValue);

						if (color) {
							tcolor = tinycolor({ r: color.r, g: color.g, b: color.b, a: color.a });
							return {tcolor: tcolor, color: color};
						}
					}

					// Get selected linked color from colorpicker input field GUID value
					if (cp.is.linkSupported()) {
						lcolor = find.colorById(targetValue);

						if (lcolor) {
							tcolor = tinycolor({ r: lcolor.r, g: lcolor.g, b: lcolor.b, a: lcolor.a });
							return {tcolor: tcolor, lcolor: lcolor};
						}
					}

					// Get selected color from input field HEX or RGB string value
					tcolor = tinycolor(targetValue);

					if (tcolor.isValid() === true) {
						return {tcolor: tcolor};
					}

					return null;
				},

				defaultColor: function() {
					return settings.transparent
								? {tcolor: tinycolor('transparent')}
								: {tcolor: tinycolor('white')};
				},

				selectedColorId: function() {
					var targetColor = cp.get.targetValue();

					if (targetColor && targetColor.color)
						return targetColor.color.id;
					else if ((targetColor = $target.attr('data-missing-template-id')))
						return targetColor;

					return null;
				},

				selectedColor: function() {
					var targetColor = cp.get.targetValue() || cp.get.defaultColor();

					if (targetColor && targetColor.tcolor)
						return cp.get.formattedString(targetColor.tcolor);

					return null;
				},

				formattedString: function(tcolor) {
					var format = settings.colorFormat;
					tcolor = tcolor || STORE.selected.tcolor;

					if (format === 'rgb') {
						return tcolor.toRgbString();
					} else if (format === 'hex') {
						if (cp.is.transparent(tcolor)) {
							return 'transparent';
						} else {
							return tcolor.toHexString();
						}
					}
				},

				linkColorsData: function(color) {
					var linkColorsData = JSON.parse(JSON.stringify(STORE.template));

					// Color can't be linked to Standard palette color
					linkColorsData.categories = linkColorsData.categories
						.filter(function(category) { return category.isStandardPalette !== true; })

					// or to other linked colors
					// or to itself
					linkColorsData.categories.forEach(function(category) {
							category.colors = category.colors.filter(function(c) {
								return !c.linkedColorId && c.id !== color.id;
							});
						});

					return linkColorsData;
				},

				adjustments: function(color) {
					var adjustments = [];

					if (typeof color.adjustments === 'string' && color.adjustments.length > 0) {
						try {
							adjustments = JSON.parse(color.adjustments);
						} catch(e) {
							// eslint-disable-next-line no-console
							console.error(e);
							return adjustments;
						}
					}

					return adjustments;
				},

				adjustedColor: function(linkedColorId, adjustment, adjustmentValue) {
					var linkedColor = find.colorById(linkedColorId);
					var colorValues = tinycolor({ r: linkedColor.r, g: linkedColor.g, b: linkedColor.b, a: linkedColor.a });

					if (typeof linkedColor !== 'object' || typeof colorValues !== 'object') return '';
					if (!adjustment || !adjustmentValue) return colorValues;

					switch (adjustment) {
						case '0': {
							return colorValues;
						}
						case 'h': {
							return colorValues.spin(adjustmentValue*1);
						}
						case 's': {
							return colorValues.saturate(adjustmentValue*1);
						}
						case 'l': {
							return colorValues.lighten(adjustmentValue*1);
						}
						default: {
							return colorValues;
						}
					}
				},
			},
			set: {
				allColors: function(tcolor, sourceEl) {
					cp.set.spectrumColors(tcolor, sourceEl);
					cp.set.editorsColors(tcolor, sourceEl);
					cp.set.selectedSwatch(tcolor, sourceEl);
					cp.set.targetColor(tcolor, sourceEl);
				},
				editorsColors: function(tcolor, sourceEl) {
					var hex = tcolor.toHex();
					var rgb = tcolor.toRgb();
					var hsl = tcolor.toHsl();

					$hex.not(sourceEl).val(hex);

					$r.not(sourceEl).val(Math.round(rgb.r));
					$g.not(sourceEl).val(Math.round(rgb.g));
					$b.not(sourceEl).val(Math.round(rgb.b));

					$h.not(sourceEl).val(Math.round(hsl.h));
					$s.not(sourceEl).val(Math.round(hsl.s * 100));
					$l.not(sourceEl).val(Math.round(hsl.l * 100));
				},
				spectrumColors: function(tcolor, sourceEl) {
					var hsl = tcolor.toHsl();
					var hsv = tcolor.toHsv();
					var sliderHue = Math.round($slider.attr('data-hue') || '0');
					var spectrumColor = tinycolor.fromRatio({
						h: hsl.s * 100 > 0 && hsl.l * 100 > 0 ? hsl.h : sliderHue,
						s: 1.0,
						l: 0.5
					});

					var dragX = hsv.s * 180;
					var dragY = 142 - (hsv.v * 142);
					dragX = Math.max(-14, Math.min(180 - 14, dragX - 14));
					dragY = Math.max(-14, Math.min(142 - 14, dragY - 14));
					$dragger.css({
						'top': dragY,
						'left': dragX
					});

					$cp.find(selector.spectrumSL).css('background-color', spectrumColor.toRgbString());

					if (hsl.s * 100 > 0 && hsl.l * 100 > 0)
						$slider
							.css('left', (Math.round(hsl.h) / 2) - 14)
							.attr('data-hue', Math.round(hsl.h));
				},
				selectedSwatch: function(tcolor, sourceEl) {
					$cp.find(selector.selectedSwatch)
						.css('background-color', cp.get.formattedString(tcolor))
						.toggleClass('color-transparent', cp.is.transparent(tcolor));
				},
				adjustmentSwatch: function(tcolor, sourceEl) {
					$cp.find(selector.adjustmentSwatch)
						.css('background-color', cp.get.formattedString(tcolor))
						.toggleClass('color-transparent', cp.is.transparent(tcolor));
				},
				targetColor: function(tcolor, sourceEl) {
					$target
						.css('background-color', cp.get.formattedString(tcolor))
						.attr('title', cp.get.formattedString(tcolor))
						.toggleClass('color-transparent', cp.is.transparent(tcolor));
				},
				targetValue: function(tcolor, color) {
					if (typeof color === 'object') {
						// Template color
						$templateTarget.val(color.id);

						if (cp.is.templateSupported())
							$container.addClass(className.template);

						if ($templateTarget !== $target)
							$target.val(cp.get.formattedString(tcolor));
					} else {
						// Standard color
						$target.val(cp.get.formattedString(tcolor));
						$container.removeClass(className.template);
						if ($templateTarget !== $target)
							$templateTarget.val('');
					}
				},
				lastUsed: function(color) {
					var index = STORE.lastUsed.indexOf(color);

					if (index === -1) {
						// New last used color
						STORE.lastUsed.push(color);
							if (STORE.lastUsed.length > 10)
								STORE.lastUsed.shift();
					} else {
						// Move already used color to the end of list
						STORE.lastUsed.splice(STORE.lastUsed.length, 1, STORE.lastUsed.splice(index, 1)[0]);
					}
				}
			},


			show: function() {
				var targetColor = cp.get.targetValue() || cp.get.defaultColor(),
					adjustment, adjustedColor;

				if (cp.is.disabled())
					return false;

				if (cp.is.anyActive())
					$(selector.target + '.' + className.active).DUIColorPicker('hide');

				if (!cp.is.alreadySetup())
					cp.setup.markup();

				if (cp.is.templateSupported() &&
					((targetColor && targetColor.color) || STORE.selected.layout === 'template')) {
					// Template
					if (targetColor && targetColor.color) {
						cp.select.templateColor(targetColor.color.id);
						$selectTemplate.DUIColorSelect('set.targetColor', targetColor.color);
						$container.addClass(className.template);
					} else {
						cp.select.color(targetColor.tcolor);
						$selectTemplate.DUIColorSelect();
						$container.removeClass(className.template);
					}
					cp.setup.view.template();
				} else if (cp.is.linkSupported() && (targetColor && targetColor.lcolor)) {
					// Link

					$selectLink.DUIColorSelect({data: cp.get.linkColorsData(targetColor.lcolor)});
					cp.select.linkColor(targetColor.lcolor.id);

					if (targetColor.lcolor.linkedColorId) {
						// Linked color
						$selectLink.DUIColorSelect('set.targetColor', find.colorById(targetColor.lcolor.linkedColorId));

						adjustment = cp.get.adjustments(targetColor.lcolor);
						adjustment = adjustment[0];
						adjustedColor = cp.get.adjustedColor(targetColor.lcolor.linkedColorId, adjustment.adjustment, adjustment.adjustmentValue);

						if (adjustment) {
							$cp.find(selector.adjustment).val(adjustment.adjustment);
							$cp.find(selector.adjustmentValue).val(adjustment.adjustmentValue);
							cp.set.adjustmentSwatch(adjustedColor, element);
						}

						cp.setup.adjustmentGuide();
						cp.setup.view.link();
					} else if (ColorTemplates.STORE.selected.category.isStandardPalette ||
							STORE.colors.filter(function(c) { return c.linkedColorId === targetColor.lcolor.id; }).length > 0) {
						// Linked color source
						$cp.find(selector.link).remove();
						$cp.find(selector.linkTab).remove();
						$cp.find(selector.standardTab).remove();
						cp.setup.view.standard();
					} else {
						cp.setup.view.standard();
					}
				} else {
					// Standard
					cp.select.color(targetColor.tcolor);

					cp.setup.view.standard();
					$container.removeClass(className.template);
				}

				cp.redraw.standard();
				cp.set.allColors(targetColor.tcolor, element);
				originalColor = targetColor.tcolor.toRgbString();

				$target.addClass(className.active);

				$(document.body).append($cp);
				cp.bind.documentEvents();

				if (STORE.selected.view)
					cp.setup.view[STORE.selected.view]();

				cp.setup.position();

				$target.trigger(Event.SHOW);
			},
			hide: function() {
				$cp.detach();
				cp.unbind.documentEvents();
				$target.removeClass(className.active);

				if (!STORE.selected.color &&
					STORE.selected.tcolor &&
					STORE.selected.tcolor.toRgbString() !== originalColor)
						cp.set.lastUsed(STORE.selected.tcolor.toRgbString());

				save.sessionData();
				$target.trigger(Event.HIDE);
			},


			spectrumDragger: function() {
				var range = $cp.find(selector.spectrumSL),
					draggerWidth = 14,
					rangeWidth, rangeLeft, rangeHeight, rangeTop;

				$dragger.css({
					width:		draggerWidth + 'px',
					left:		-draggerWidth + 'px',
					marginLeft:	(draggerWidth / 2) + 'px'
				});

				range.bind('mousedown', function(e) {
					var offset = $(this).offset();
					rangeWidth = this.offsetWidth;
					rangeLeft = offset.left;
					rangeHeight = this.offsetHeight;
					rangeTop = offset.top;
					MOUSEDOWN = true;
					updateDragger(e);
					return false;
				});

				range.bind('mousemove', function(e) {
					updateDragger(e);
				});

				function updateDragger(e) {
					var pageX = e.clientX + window.pageXOffset;
					var pageY = e.clientY + window.pageYOffset;

					if (MOUSEDOWN &&
							pageX >= rangeLeft && pageX <= (rangeLeft + rangeWidth) &&
							pageY >= rangeTop && pageY <= (rangeTop + rangeHeight)) {
						var dragX = Math.max(0, Math.min(pageX - rangeLeft, rangeWidth));
						var dragY = Math.max(0, Math.min(pageY - rangeTop, rangeHeight));

						$dragger.css({
							left:	(dragX - draggerWidth) + 'px',
							top:	(dragY - draggerWidth / 2) + 'px'
						});

						var hue = Math.round($slider.attr('data-hue') || '0');
						var saturation = parseFloat(dragX / rangeWidth);
						var lightness = parseFloat((rangeHeight - dragY) / rangeHeight);

						var tcolor = tinycolor.fromRatio({
							h: hue,
							s: saturation,
							v: lightness
						});

						if (tcolor.isValid && tcolor.getFormat() === 'hsv')
							cp.handleColorChange(e, tcolor);
					}
				}
			},

			hueSlider: function() {
				var range = $cp.find(selector.spectrumH),
					sliderWidth = 14,
					rangeWidth, rangeLeft;

				$slider.css({
					width:		sliderWidth + 'px',
					left:		-sliderWidth + 'px',
					marginLeft:	(sliderWidth / 2) + 'px'
				});

				range.bind('mousedown', function(e) {
					rangeWidth = this.offsetWidth - 1;
					rangeLeft = $(this).offset().left;
					MOUSEDOWN = true;
					updateSlider(e);
					return false;
				});

				range.bind('mousemove', function(e) {
					updateSlider(e);
				});

				function updateSlider(e) {
					var pageX = e.clientX + window.pageXOffset;

					if (MOUSEDOWN && pageX >= rangeLeft && pageX <= (rangeLeft + rangeWidth)) {
						var hue = (pageX - rangeLeft) * 2;
						var hsl = [hue, $s.val() || '100%', $l.val() || '50%'];
						var tcolor = tinycolor('hsl ' + hsl.join(' '));

						$slider
							.css('left', (pageX - rangeLeft - sliderWidth) + 'px')
							.attr('data-hue', hue);

						if (tcolor.isValid && tcolor.getFormat() === 'hsl')
							cp.handleColorChange(e, tcolor);
					}
				}
			},


			select: {
				color: function(tcolor) {
					STORE.selected.color = null;
					STORE.selected.lcolor = null;
					STORE.selected.tcolor = tcolor;
				},
				templateColor: function(selectedColorId) {
					STORE.selected.lcolor = null;
					STORE.selected.color = find.colorById(selectedColorId);
					STORE.selected.tcolor = tinycolor({
						r: STORE.selected.color.r,
						g: STORE.selected.color.g,
						b: STORE.selected.color.b,
						a: STORE.selected.color.a
					});
				},
				linkColor: function(selectedColorId, linkedColorId, adjustments) {
					var linkedCategory,
						adjustedColor;

					STORE.selected.color = null;
					STORE.selected.lcolor = find.colorById(selectedColorId);

					if (linkedColorId && adjustments) {
						linkedCategory = STORE.categories.filter(function(c) {
							return c.colors.filter(function(c) { return c.id === linkedColorId; }).length > 0;
						})[0];

						adjustedColor = cp.get.adjustedColor(linkedColorId, adjustments[0].adjustment, adjustments[0].adjustmentValue);

						STORE.selected.lcolor.linkedColorId = linkedColorId;
						STORE.selected.lcolor.linkedCategoryId = linkedCategory.id;

						STORE.selected.lcolor.r = adjustedColor._r;
						STORE.selected.lcolor.g = adjustedColor._g;
						STORE.selected.lcolor.b = adjustedColor._b;
						STORE.selected.lcolor.a = adjustedColor._a;
						STORE.selected.lcolor.adjustments = JSON.stringify(adjustments);
					}

					STORE.selected.tcolor = tinycolor({
						r: STORE.selected.lcolor.r,
						g: STORE.selected.lcolor.g,
						b: STORE.selected.lcolor.b,
						a: STORE.selected.lcolor.a
					});
				}
			},


			redraw: {
				standardPalette: function() {
					var standardPaletteCategory;
					var colors;

					// Project color template standard palette
					if (cp.is.templateSupported() || cp.is.linkSupported())
						standardPaletteCategory = STORE.categories.filter(function(c) { return c.isStandardPalette === true; })[0];

					if (standardPaletteCategory) {
						colors = standardPaletteCategory.colors
							.filter(function(color) { return settings.transparent || color.a !== 0; });
					} else {
						colors = settings.standardPaletteColors
							.filter(function(color) { return settings.transparent || color !== 'transparent'; })
							.map(function(color) { return {colorString: color}; });
					}

					$cp.find(selector.standardPalette).html(cp.render.palette(colors));
				},
				lastUsedPalette: function() {
					if (STORE.lastUsed.length > 0)
						$cp
							.find(selector.lastUsed)
								.css('display', 'block')
							.find(selector.lastUsedPalette)
								.html(cp.render.palette(STORE.lastUsed.map(function(c) { return {colorString: c}; })))
					else
						$cp.find(selector.lastUsed).css('display', 'none')
				},
				standard: function() {
					cp.redraw.standardPalette();
					cp.redraw.lastUsedPalette();
				}
			},

			render: {
				palette: function(colors) {
					return colors && colors.length > 0
							? colors.map(cp.render.paletteColor).join('')
							: '';
				},
				paletteColor: function(color) {
					var colorValues, colorString;

					if (color.colorString === 'transparent' ||
						color.colorString === 'rgba(0, 0, 0, 0)' ||
						color.a === 0) {
							return '<div class="colorpicker-palette-color color-transparent"'+
										'style="color: transparent" title="transparent">'+
									'</div>';
					}

					if (color.colorString) {
						colorString = color.colorString;
					} else {
						colorValues = tinycolor({ r: color.r, g: color.g, b: color.b });
						colorString = colorValues.toRgbString();
					}

					return '<div class="colorpicker-palette-color"'+
								'style="color:'+ colorString +'" title="'+ colorString +'">'+
							'</div>';
				},
				categorySelectOptions: function(categories) {
					return categories && categories.length > 0
							? categories.filter(function(c) { return c.isStandardPalette !== true; }).map(cp.render.categoryOption).join('')
							: '';
				},
				categoryOption: function(category) {
					return typeof category === 'object' ?
								'<div class="colorpicker-category-option" data-id="'+ category.id +'">'+
                                '<div class="colorpicker-category-name">' + (category.name ? $('<div/>').text(category.name).html() : '') +'</div>'+
									'<div class="colorpicker-category-colors">'+
										cp.render.palette(category.colors.slice(0,5)) +
									'</div>'+
								'</div>'
							: '';
				},
				categoryPaletteColor: function(color) {
					return '<tr data-id="'+ color.id +'">'+
								'<td>'+ cp.render.paletteColor(color) +'</td>'+
                                '<td>' + (color.tags ? $('<div/>').text(color.tags).html() : '') +'</td>'+
							'</tr>';
				},
				categoryPaletteColors: function(colors) {
					return colors && colors.length > 0
							? colors.map(cp.render.categoryPaletteColor).join('')
							: '';
				}
			},


			event: {
				click: {
					cp: function(event) {
						event.stopPropagation();
					},
					target: function(event) {
						event.stopPropagation();
						if ($cp && $cp.get(0).contains(event.target))
							return;

						if (cp.is.active())
							cp.hide();
						else
							cp.show();
					},
					standardPalette: function(event) {
						var color = $(this).attr('title');
						var tcolor = tinycolor(color);
						cp.handleColorChange(event, tcolor);
						cp.hide();
					},
					lastUsed: function(event) {
						var color = $(this).css('color');
						var tcolor = tinycolor(color);
						cp.handleColorChange(event, tcolor);
						cp.hide();
					},
					tab: function(event) {
						var view = $(this).attr('data-view');

						if (cp.is.templateSupported() && view === 'standard' && STORE.selected.color) {
							STORE.selected.color = null;
							cp.set.allColors(STORE.selected.tcolor, this);
							$selectTemplate.DUIColorSelect();
						}

						if (typeof cp.setup.view[view] === 'function')
							cp.setup.view[view]();

						cp.setup.position();
						event.stopPropagation();
					},
					templateColor: function(event, color) {
						if (color) {
							cp.select.templateColor(color.id);
							cp.set.targetValue(STORE.selected.tcolor, STORE.selected.color);
							cp.set.targetColor(STORE.selected.tcolor, this);

							// Old deprecated event
							$target.trigger('colorPicked.DUIcolorPicker', [cp.get.formattedString(), STORE.selected.tcolor, STORE.selected.color]);

							$target.trigger(Event.COLORCHANGE, [cp.get.formattedString(), STORE.selected.tcolor, STORE.selected.color]);
							$target.removeAttr('data-missing-template-id');

							cp.hide();
						}

						event.stopPropagation();
					},
					linkColor: function(event, color) {
						if (color) {
							var adjustments = [{
								adjustment: $cp.find(selector.adjustment).val(),
								adjustmentValue: $cp.find(selector.adjustmentValue).val()
							}];

							cp.select.linkColor(STORE.selected.lcolor.id, color.id, adjustments);
							cp.set.targetValue(STORE.selected.tcolor, STORE.selected.lcolor);
							cp.set.targetColor(STORE.selected.tcolor, this);
							cp.set.adjustmentSwatch(STORE.selected.tcolor, this);

							$target.trigger(Event.COLORCHANGE, [cp.get.formattedString(), STORE.selected.tcolor, STORE.selected.lcolor]);
						}

						event.stopPropagation();
					}
				},

				mousedown: {
					document: function(event) {
						if (cp.is.active() &&
							event.target !== element &&
							!$cp.get(0).contains(event.target))
								cp.hide();
					}
				},

				mouseup: {
					document: function(event) {
						if (MOUSEDOWN) MOUSEDOWN = false;
					}
				},

				change: {
					target: function(event) {
						var targetColor = cp.get.targetValue();

						if (targetColor && targetColor.tcolor)
							cp.set.targetColor(targetColor.tcolor);
					}
				},

                paste: function (event) {
                    var pastedData = event.originalEvent.clipboardData.getData('text');
                    var tcolor = tinycolor(pastedData, this);
                    if (pastedData.length === 6 && tcolor.isValid && tcolor.getFormat() === 'hex')
                        cp.handleColorChange(event, tcolor);

                },

				keyup: {
					hexInput: function(event) {
						var color = $(this).val();
						var tcolor = tinycolor(color, this);

						if (color.length === 6 && tcolor.isValid && tcolor.getFormat() === 'hex')
							cp.handleColorChange(event, tcolor);
					},
					rgbInputs: function(event) {
						var rgb = [$r.val(), $g.val(), $b.val()];
						var tcolor = tinycolor('rgb ' + rgb.join(' '));

						if (tcolor.isValid && tcolor.getFormat() === 'rgb')
							cp.handleColorChange(event, tcolor);
					},
					hslInputs: function(event) {
						var hsl = [$h.val(), $s.val(), $l.val()];
						var tcolor = tinycolor('hsl ' + hsl.join(' '));

						if (tcolor.isValid && tcolor.getFormat() === 'hsl')
							cp.handleColorChange(event, tcolor);
					}
				}
			},

			handleInputKeydown: function(event) {
				if ($.inArray(event.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
						// Ctrl+A
					(event.keyCode == 65 && event.ctrlKey === true) ||
						// Ctrl+C
					(event.keyCode == 67 && event.ctrlKey === true) ||
						// Ctrl+X
					(event.keyCode == 88 && event.ctrlKey === true) ||
						// Home, end, left, right
					(event.keyCode >= 35 && event.keyCode <= 39)) {
						return;
				}
				if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57))
					&& (event.keyCode < 96 || event.keyCode > 105)) {
						event.preventDefault();
				}
			},
			handleAdjustmentKeydown: function(event) {
				if (event.keyCode === 109 || event.keyCode === 189 || event.keyCode === 173)
					return;
				else
					cp.handleInputKeydown(event);
			},
			handleColorChange: function(event, tcolor) {
				if (cp.is.linkSupported()) {
					// Link Color
					delete STORE.selected.lcolor.linkedColorId;
					delete STORE.selected.lcolor.linkedCategoryId;

					STORE.selected.lcolor.r = tcolor._r;
					STORE.selected.lcolor.g = tcolor._g;
					STORE.selected.lcolor.b = tcolor._b;
					STORE.selected.lcolor.a = tcolor._a;
					STORE.selected.lcolor.adjustments = '';
					STORE.selected.tcolor = tcolor;

					cp.set.targetValue(tcolor, STORE.selected.lcolor);
					cp.set.allColors(tcolor, event.target);

					cp.updateLinkedColors(STORE.selected.lcolor);

					$target.trigger(Event.COLORCHANGE, [cp.get.formattedString(), STORE.selected.tcolor, STORE.selected.lcolor]);
				} else {
					// Standard color
					cp.select.color(tcolor);
					cp.set.targetValue(tcolor);
					cp.set.allColors(tcolor, event.target);

					// Old deprecated event
					$target.trigger('colorPicked.DUIcolorPicker', [cp.get.formattedString(), STORE.selected.tcolor]);

					$target.trigger(Event.COLORCHANGE, [cp.get.formattedString(), STORE.selected.tcolor]);
					$target.removeAttr('data-missing-template-id');
				}

				event.stopPropagation();
			},
			handleAdjustmentChange: function(event) {
				var adjustments = [{
					adjustment: $cp.find(selector.adjustment).val(),
					adjustmentValue: $cp.find(selector.adjustmentValue).val()
				}];

				if (STORE.selected.lcolor.id && STORE.selected.lcolor.linkedColorId) {
					cp.select.linkColor(STORE.selected.lcolor.id, STORE.selected.lcolor.linkedColorId, adjustments);
					cp.set.targetValue(STORE.selected.tcolor, STORE.selected.lcolor);
					cp.set.targetColor(STORE.selected.tcolor, this);
					cp.set.adjustmentSwatch(STORE.selected.tcolor, this);

					$target.trigger(Event.COLORCHANGE, [cp.get.formattedString(), STORE.selected.tcolor, STORE.selected.lcolor]);
				}
			},
			updateLinkedColors: function(lcolor) {
				var linkedColors = STORE.colors.filter(function(c) { return c.linkedColorId === lcolor.id; });

				// Recalculate color adjustments for all linked colors
				// after source color has been changed
				linkedColors.forEach(function(linkedColor) {
					var adjustment = cp.get.adjustments(linkedColor),
						adjustedColor;

					adjustment = adjustment[0];

					if (adjustment) {
						adjustedColor = cp.get.adjustedColor(lcolor.id, adjustment.adjustment, adjustment.adjustmentValue);
						linkedColor.r = adjustedColor._r;
						linkedColor.g = adjustedColor._g;
						linkedColor.b = adjustedColor._b;
						linkedColor.a = adjustedColor._a;
					}
				});
			},


			bind: {
				standardEvents: function() {
					$cp.bind('click', cp.event.click.cp);
					$cp.delegate(selector.standardPalette + ' ' + selector.paletteColor, 'click' + EVENTNAMESPACE, cp.event.click.standardPalette);
					$cp.delegate(selector.lastUsedPalette + ' ' + selector.paletteColor, 'click' + EVENTNAMESPACE, cp.event.click.lastUsed);

					// Colorpicker views
					$cp.delegate(selector.moreColorsLink, 'click' + EVENTNAMESPACE, cp.setup.view.spectrum);
					$cp.delegate(selector.standardPaletteLink, 'click' + EVENTNAMESPACE, cp.setup.view.palette);

					// Colors editor
					$cp.delegate(selector.hex, 'keyup' + EVENTNAMESPACE, cp.event.keyup.hexInput);
					$cp.delegate(selector.rgbEditor + ' input', 'keydown' + EVENTNAMESPACE, cp.handleInputKeydown);
					$cp.delegate(selector.hslEditor + ' input', 'keydown' + EVENTNAMESPACE, cp.handleInputKeydown);
					$cp.delegate(selector.rgbEditor + ' input', 'keyup' + EVENTNAMESPACE, cp.event.keyup.rgbInputs);
					$cp.delegate(selector.hslEditor + ' input', 'keyup' + EVENTNAMESPACE, cp.event.keyup.hslInputs);
				},
				templateEvents: function() {
					$cp.delegate(selector.tab, 'click' + EVENTNAMESPACE, cp.event.click.tab);
					$selectTemplate.bind('colorSelect.DUIColorSelect', cp.event.click.templateColor);
				},
				linkEvents: function() {
					$cp.delegate(selector.tab, 'click' + EVENTNAMESPACE, cp.event.click.tab);
					$cp.delegate(selector.adjustment, 'change' + EVENTNAMESPACE, cp.setup.adjustmentGuide);
					$cp.delegate(selector.adjustment, 'change' + EVENTNAMESPACE, cp.handleAdjustmentChange);
					$cp.delegate(selector.adjustmentValue, 'keydown' + EVENTNAMESPACE, cp.handleAdjustmentKeydown);
					$cp.delegate(selector.adjustmentValue, 'change keyup' + EVENTNAMESPACE, cp.handleAdjustmentChange);
					$selectLink.bind('colorSelect.DUIColorSelect', cp.event.click.linkColor);
				},
				targetEvents: function() {
					$container.bind('click' + EVENTNAMESPACE, cp.event.click.target);
					$target.bind('change' + EVENTNAMESPACE, cp.event.change.target);
				},
				documentEvents: function() {
					$(document).bind('mouseup' + EVENTNAMESPACE, cp.event.mouseup.document);
					$(document).bind('mousedown' + EVENTNAMESPACE, cp.event.mousedown.document);
				}
			},

			unbind: {
				documentEvents: function() {
					$(document).unbind('mouseup' + EVENTNAMESPACE);
					$(document).unbind('mousedown' + EVENTNAMESPACE);
				},
				targetEvents: function() {
					$container.unbind('click' + EVENTNAMESPACE);
					$target.unbind('change' + EVENTNAMESPACE);
				}
			},

			invoke: function(query, context, methodArguments) {
				var	method, response;
				context = element || context;

				methodArguments = methodArguments || queryArguments;

				if (typeof query == 'string' && instance !== undefined) {
					query = query.split('.');
					$.each(query, function(index, name) {
						if ($.isPlainObject( instance[name])) {
							instance = instance[name];
							return true;
						}
						else if ($.isFunction( instance[name])) {
							method = instance[name];
							return true;
						}
						return false;
					});
				}

				if ($.isFunction(method)) {
					response = method.apply(context, methodArguments);

					if (response !== undefined) {
						returnValue = response;
					}
				}
			}

		};

		if (methodInvoked) {
			if (instance === undefined) {
				cp.initialize();
			}
			cp.invoke(query);
		} else {
			if (instance !== undefined) {
				instance.invoke('destroy');
			}
			cp.initialize();
		}

	});

	return (returnValue !== undefined)
		? returnValue
		: this;
};

var	NAME						= 'DUIColorPicker',
	NAMESPACE					= NAME,
	EVENTNAMESPACE				= '.' + NAMESPACE,
	MOUSEDOWN 					= false,

	Event = {
		SHOW					: 'show' + EVENTNAMESPACE,
		HIDE					: 'hide' + EVENTNAMESPACE,
		COLORCHANGE				: 'colorChange' + EVENTNAMESPACE
	};

var DEFAULTSETTINGS = {
	layout						: 'standard',

	selected:	{
		tab						: 'standard',
		view					: 'spectrum',
	},

	lastUsed					: [],

	transparent					: true,
	colorFormat					: 'hex',
	minCharacters				: 1,

	selector: {
		templateTarget:			'input[id*="ColorPlaceholder"]',
		target:					'.colorpicker-target',
		tab:					'.colorpicker-tab',
		standardTab:			'.colorpicker-tab[data-view="standard"]',
		templateTab:			'.colorpicker-tab[data-view="template"]',
		linkTab:				'.colorpicker-tab[data-view="link"]',
		standard:				'.colorpicker-standard',
		template:				'.colorpicker-template',
		link:					'.colorpicker-link',
		selectTemplate:			'.colorpicker-select-template',
		selectLink:				'.colorpicker-select-link',
		paletteColor:			'.colorpicker-palette-color',
		palettes:				'.colorpicker-palettes',
		spectrums:				'.colorpicker-spectrums',
		spectrumSL:				'.colorpicker-spectrum-sl',
		spectrumH:				'.colorpicker-spectrum-hue',
		dragger:				'.colorpicker-spectrum-dragger',
		slider:					'.colorpicker-spectrum-slider',
		moreColorsLink:			'.colorpicker-more-colors-link',
		standardPaletteLink:	'.colorpicker-standard-palette-link',
		standardPalette:		'.colorpicker-palette-standard',
		lastUsed:				'.colorpicker-last-used',
		lastUsedPalette:		'.colorpicker-palette-last-used',
		editors:				'.colorpicker-editors',
		hexEditor:				'.colorpicker-hex-editor',
		rgbEditor:				'.colorpicker-rgb-editor',
		hslEditor:				'.colorpicker-hsl-editor',
		selectedSwatch:			'.colorpicker-selected-swatch',
		hex:					'.colorpicker-hex',
		r:						'.colorpicker-r',
		g:						'.colorpicker-g',
		b:						'.colorpicker-b',
		h:						'.colorpicker-h',
		s:						'.colorpicker-s',
		l:						'.colorpicker-l',
		adjustment:				'.colorpicker-adjustment',
		adjustmentValue:		'.colorpicker-adjustment-value',
		adjustmentSwatch:		'.colorpicker-adjustment-swatch',
		adjustmentGuide:		'.colorpicker-adjustment-guide',
	},

	className: {
		target:					'colorpicker-target',
		template:				'colorpicker-template',
		active:					'active',
		selected:				'selected'
	},

	standardPaletteColors: [
			'#ffffff', '#000000', '#eeecdf', '#1f487c', '#4f81bc', '#c0504e', '#9bbb58', '#8064a1', '#4aacc5', '#f79647',
			'#f2f2f2', '#7f7f7f', '#ded9c3', '#c7d9f1', '#dce4f1', '#f1dcdb', '#ecf1dd', '#e6e0ec', '#dbeef4', '#fdeadb',
			'#d8d8d8', '#595959', '#c5bd98', '#8db3e2', '#b7cde2', '#e3bab8', '#d7e3bd', '#cdc1d9', '#b7dde8', '#fcd5b6',
			'#bfbfbf', '#3f3f3f', '#938a53', '#548dd4', '#95b3d7', '#da9695', '#c3d79c', '#b2a2c7', '#92cddb', '#f5c199',
			'#a5a5a5', '#262626', '#494329', '#16365d', '#366092', '#953735', '#78913d', '#5f497a', '#30859a', '#e36c08',
			'#7f7f7f', '#0c0c0c', '#1d1b0f', '#0f243f', '#234060', '#622524', '#4f6029', '#3f3152', '#1f5967', '#974806',
			'#c00000', '#fe0000', '#ffc000', '#fefe00', '#92d14f', '#00af50', '#01b0f1', '#0071c1', '#012060', '#7030a0',
			'#EE248F', '#00ada8', '#5f388b', '#D31F00', '#EDF900', '#00DB95', '#16E000', '#6ACE00', '#D60003', '#00BFC9',
			'transparent'
	],

	templates: {
		container: '<div class="colorpicker-container"></div>',
		markup: (function() {
			return [
				'<div class="dui colorpicker">',
					'<div class="colorpicker-tabs">',
						'<div class="colorpicker-tab active" data-view="standard"><span>Standard</span></div>',
						'<div class="colorpicker-tab" data-view="template"><span>Template</span></div>',
						'<div class="colorpicker-tab" data-view="link"><span>Link</span></div>',
					'</div>',
					'<div class="colorpicker-tab-content colorpicker-standard">',
						'<div class="colorpicker-selectors">',
							'<div class="colorpicker-palettes">',
								'<div class="colorpicker-palette colorpicker-palette-standard">',
								'</div>',
								'<div class="colorpicker-view-link colorpicker-more-colors-link"><span>More colors</span></div>',
							'</div>',
							'<div class="colorpicker-spectrums" style="display: none">',
								'<div class="colorpicker-spectrum-sl" style="background-color: #c0504e;">',
									'<div class="colorpicker-spectrum-saturation">',
										'<div class="colorpicker-spectrum-lightness">',
											'<div class="colorpicker-spectrum-dragger"></div>',
										'</div>',
									'</div>',
								'</div>',
								'<div class="colorpicker-spectrum-hue">',
									'<div class="colorpicker-spectrum-slider"></div>',
								'</div>',
								'<div class="colorpicker-view-link colorpicker-standard-palette-link"><span>Standard Palette</span></div>',
							'</div>',
						'</div>',
						'<div class="colorpicker-editors">',
							'<div class="colorpicker-editor colorpicker-hex-editor">',
								'<label class="colorpicker-editor-label colorpicker-hex-editor-label">HEX</label>',
								'<input type="text" class="colorpicker-editor-input colorpicker-hex" maxlength="6">',
							'</div>',
							'<div class="colorpicker-selected-swatch">',
							'</div>',
							'<div class="colorpicker-editor colorpicker-rgb-editor">',
								'<label class="colorpicker-editor-label">RGB</label>',
								'<input type="text" class="colorpicker-editor-input colorpicker-r" maxlength="3">',
								'<input type="text" class="colorpicker-editor-input colorpicker-g" maxlength="3">',
								'<input type="text" class="colorpicker-editor-input colorpicker-b" maxlength="3">',
							'</div>',
							'<div class="colorpicker-editor colorpicker-hsl-editor">',
								'<label class="colorpicker-editor-label">HSL</label>',
								'<input type="text" class="colorpicker-editor-input colorpicker-h" maxlength="3">',
								'<input type="text" class="colorpicker-editor-input colorpicker-s" maxlength="3">',
								'<input type="text" class="colorpicker-editor-input colorpicker-l" maxlength="3">',
							'</div>',
						'</div>',
						'<div class="colorpicker-last-used">',
							'<div class="colorpicker-palette">',
								'<div class="colorpicker-palette-label">Last used</div>',
								'<div class="colorpicker-palette-last-used"></div>',
							'</div>',
						'</div>',
					'</div>',
					'<div class="colorpicker-tab-content colorpicker-template" style="display: none">',
						'<input type="text" class="colorpicker-select-template" />'+
					'</div>',
					'<div class="colorpicker-tab-content colorpicker-link" style="display: none">',
						'<input type="text" class="colorpicker-select-link" />'+
						'<div class="colorpicker-adjustments">'+
							'<div class="colorpicker-adjustment-group">'+
								'<label>Adjustment</label>'+
								'<select class="colorpicker-adjustment">'+
									'<option value="h">Hue</option>'+
									'<option value="s">Saturation</option>'+
									'<option value="l">Lightness</option>'+
								'</select>'+
							'</div>'+
							'<div class="colorpicker-adjustment-value-group">'+
								'<label>Value <span class="colorpicker-adjustment-guide">-100 to 100</span></label>'+
								'<input type="text" class="colorpicker-editor-input colorpicker-adjustment-value">'+
								'<div class="colorpicker-adjustment-swatch"></div>'+
							'</div>'+
						'</div>'+
					'</div>',
				'</div>'
			].join('');
		})()
	}
};

// Extend find
find.colorPickerTargets = function() {
	return $(DEFAULTSETTINGS.selector.target);
};

find.colorPickers = function() {
	return this.colorPickerTargets()
		.map(function() {
			return $(this).data(NAMESPACE);
		}).get();
};

find.activeColorPicker = function() {
	return this.colorPickers()
		.filter(function(cp) {
			return cp.is.active();
		})[0];
};

// jQuery interface
$.fn.DUIColorPicker = DUIColorPicker;
$.fn.DUIColorPicker.settings = DEFAULTSETTINGS;
$.fn.DUIColorPicker.find = find;
$.fn.DUIColorPicker.load = load;

$.fn.DUIcolorPicker = $.fn.DUIColorPicker;
})();


/**
 * ------------------------------------------------------------------------
 * DUI ColorSelect Control
 * ------------------------------------------------------------------------
 */

(function(){

var DUIColorSelect = function(config) {
	var query			= arguments[0],
		methodInvoked	= (typeof query == 'string'),
		queryArguments	= [].slice.call(arguments, 1),
		returnValue;

	$(this).each(function() {
		var
			settings = ( $.isPlainObject(config) )
						? $.extend(true, {}, $.fn.DUIColorSelect.settings, config)
						: $.extend({}, $.fn.DUIColorSelect.settings),

			className					= settings.className,
			selector					= settings.selector,
			templates					= settings.templates,
			colorTemplate				= settings.colorTemplate,
			maxCategoryColors			= settings.maxCategoryColors,
			element						= this,
			$target						= $(this),
			instance					= $target.data(NAMESPACE),
			data						= settings.data,
			layout						= settings.layout,
			categories 					= [],
			colors						= [],
			$container,
			$colorMenu,
			$colorSearch,
			$categoryMain,
			$categoryMenu,
			$cs,
			cs;

		cs = {

			initialize: function() {
				cs.setup.markup();
				cs.set.data(data);

				instance = cs;

				$target.data(NAMESPACE, instance);
			},

			destroy: function() {
				if ($cs)
					$cs.remove();

				$target
					.removeData(NAMESPACE)
					.removeClass(className.target)
					.removeClass(className.active)
					.removeAttr('style')
					.unwrap();
			},

			enable: function() {
				$target.removeAttr('disabled');
				cs.bind.targetEvents();
			},
			disable: function() {
				$target.attr('disabled', 'disabled');
				cs.unbind.targetEvents();
			},

			setup: {
				markup: function() {
					if (layout === 'category')
						$cs = $(templates.categorySelect);
					else
						$cs = $(templates.categorySelect + templates.colorSelect);

					$colorMenu		= $cs.find(selector.colorMenu);
					$colorSearch	= $cs.find(selector.colorSearch);
					$categoryMain	= $cs.find(selector.categoryMain);
					$categoryMenu	= $cs.find(selector.categoryMenu).css('display', 'none');

					$target
						.addClass(className.target)
						.wrap(templates.container);

					$container = $target.parent();
					$container.append($cs);

					$colorSearch.val(STORE.search.keyword);

					if (!cs.is.disabled())
						cs.bind.standardEvents();
				},
				selectedColor: function() {
					var targetColor = cs.get.targetColor();
					var targetMenuItem;

					$colorMenu.find('.' + className.selected).removeClass(className.selected);

					if (targetColor) {
						targetMenuItem = $colorMenu.find('[data-id="'+ targetColor.id +'"]');
						if (targetMenuItem.length > 0) {
							targetMenuItem.addClass(className.selected)
						}
					}
				},
				selectedCategory: function() {
					var selectedCategory = cs.get.selectedCategory();
					var selectedCategoryId = selectedCategory ? selectedCategory.id : settings.allCategoriesId;
					var targetMenuItem;

					$categoryMenu.find('.' + className.selected).removeClass(className.selected);

					if (selectedCategoryId) {
						targetMenuItem = $categoryMenu.find('[data-id="'+ selectedCategoryId +'"]');
						if (targetMenuItem.length > 0) {
							targetMenuItem.addClass(className.selected)
						}
					}
				}
			},

			is: {
				alreadySetup: function() {
					return !!$cs;
				},
				loaded: function() {
					return !$colorMenu.is(':empty');
				},
				active: function() {
					return $target.hasClass(className.active);
				},
				categoriesOpen: function() {
					return $categoryMenu.hasClass(className.active);
				},
				disabled: function() {
					return $target.is(':disabled');
				}
			},

			get: {
				targetColor: function() {
					var targetValue = $target.val();
					var targetColor = colors.filter(function(c) { return c.id === targetValue; })[0];

					if (targetColor) {
						return targetColor;
					}

					return null;
				},
				selectedCategoryId: function() {
					return $categoryMain.find(selector.category).attr('data-id');
				},
				selectedCategory: function() {
					var selectedCategoryId = cs.get.selectedCategoryId();
					var category = categories.filter(function(c) { return c.id === selectedCategoryId; })[0];

					if (category) return category;

					return null;
				},
				colorCategory: function(color) {
					return categories.filter(function(category) {
						return category.colors.filter(function(c){ return c.id === color.id; }).length > 0;
					})[0];
				}
			},
			set: {
				targetColor: function(color) {
					var category = cs.get.colorCategory(color);
					STORE.selected.category = category;

					$target.val(color.id);
					$colorSearch.val(STORE.search.keyword);

					cs.redraw.categoryMain(category);
					cs.redraw.colors(category.colors);
					cs.setup.selectedColor();
				},

				targetCategory: function(category) {
					STORE.selected.category = category;

					if (layout === 'category') {
						$target.val(STORE.selected.category.id);
						cs.redraw.categoryMain(STORE.selected.category);
					} else {
						cs.redraw.categoryMain(STORE.selected.category);
						cs.redraw.colors(STORE.selected.category.colors);
						cs.setup.selectedColor();
					}
				},

				noSelection: function() {
					$target.val('');
					$colorSearch.val('');

					STORE.selected.category = null;
					STORE.search.keyword = '';

					cs.redraw.categoryMain();
					cs.redraw.colors();
				},

				data: function(data) {
					var categoryId, category;

					if (data) {
						colorTemplate = data;
					} else if (!colorTemplate) {
						colorTemplate = STORE.template;
					}

					if (colorTemplate.categories) {
						if (settings.standardPalette)
							categories = colorTemplate.categories;
						else {
							categories = colorTemplate.categories
								.filter(function(c) { return c.isStandardPalette !== true; });
						}

						if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART) {
							var enabledCategories = ChartCreatorSetup.getEnabledCategories();
							if (enabledCategories) {
								categories = categories.filter(function (c) { return enabledCategories.indexOf(c.id) > -1; });
							}
						}

						colors = categories
							.map(function(c) { return c.colors; })
							.reduce(function(a, b) { return a.concat(b); });
					}

					if (layout === 'category') {
						categoryId = $target.val();
						category = categories.filter(function(c) { return c.id === categoryId; })[0];
						if (category) {
							cs.redraw.categoryMain(category);
						} else {
							$target.val(categories[0].id);
							cs.redraw.categoryMain(categories[0]);
						}
					} else {
						categoryId = STORE.selected.category ? STORE.selected.category.id : null;
						category = categories.filter(function(c) { return c.id === categoryId; })[0];

						if (category) {
							cs.redraw.categoryMain(STORE.selected.category);
							cs.redraw.colors(STORE.selected.category.colors);
							cs.setup.selectedColor();
						} else {
							STORE.selected.category = null;
							cs.redraw.categoryMain();
							cs.redraw.colors();
						}
					}
				}
			},

			openCategories: function() {
				cs.redraw.categories(categories);
				$categoryMenu.css('display', 'block').addClass(className.active);
				$categoryMain.addClass(className.active);

				cs.setup.selectedCategory();

				cs.bind.documentEvents();
			},

			closeCategories: function() {
				$categoryMenu.css('display', 'none').removeClass(className.active);
				$categoryMain.removeClass(className.active);

				cs.unbind.documentEvents();
			},


			search: function(keyword) {
				var category = cs.get.selectedCategory();

				STORE.search.keyword = keyword;

				if (category) cs.redraw.colors(category.colors);
				else cs.redraw.colors();

				cs.setup.selectedColor();
			},
			clearSearch: function() {
				var category = cs.get.selectedCategory();

				$colorSearch.val('');
				STORE.search.keyword = '';

				if (category) cs.redraw.colors(category.colors);
				else cs.redraw.colors();

				cs.setup.selectedColor();
			},
			searchFilter: function(color) {
				return ~color.tags.toLowerCase().indexOf(STORE.search.keyword.toLocaleLowerCase());
			},


			redraw: {
				categories: function(categoriesArray) {
					if (layout === 'category')
						maxCategoryColors = Math.floor((($container.width() / 2) - 14) / 16);
					else
						maxCategoryColors = Math.floor(($container.width() - 14 - 17) / 16);

					categoriesArray = categoriesArray || categories;
					$categoryMenu.html(cs.render.categories(categoriesArray));
				},
				colors: function(colorsArray) {
					colorsArray = colorsArray || colors;

					if (STORE.search.keyword)
						colorsArray = colorsArray.filter(cs.searchFilter);

					$colorMenu.html(cs.render.colors(colorsArray));
				},
				categoryMain: function(category) {
					category = category || STORE.selected.category;

					if (category) {
						$categoryMain.html(cs.render.selectedCategory(category));
					} else {
						$categoryMain.html(cs.render.defaultCategory);
					}
				}
			},

			render: {
				categories: function (categories) {
					return  (settings.allCategories === true ?
								'<div class="colorselect-category" data-id="'+ settings.allCategoriesId +'">'+
									'<div class="colorselect-category-name">'+ settings.allCategoriesLabel +'</div>'+
								'</div>' : '') +
							categories.map(cs.render.category).join('');
				},
				colors: function(colors) {
					return colors.map(cs.render.color).join('');
				},
				category: function (category) {
					var sliceColors = category.colors.length > maxCategoryColors;
					var maxColors = sliceColors ? maxCategoryColors - 1 : maxCategoryColors;
					return '<div class="colorselect-category" data-id="'+ category.id +'">'+
                           '<div class="colorselect-category-name">' + (category.name ? $('<div/>').text(category.name).html() : '') +'</div>'+
								'<div class="colorselect-category-colors">'+
									category.colors.slice(0, maxColors).map(cs.render.paletteColor).join('') +
									(sliceColors ? ' ... ' : '') +
								'</div>'+
							'</div>';
				},
				color: function(color) {
					return '<div class="colorselect-color" data-id="'+ color.id +'" title="'+ color.tags +'">'+
                           '<div class="colorselect-color-tags">' + (color.tags ? $('<div/>').text(color.tags).html() : '') +'</div>'+
								cs.render.paletteColor(color) +
							'</div>';
				},
				defaultCategory: function() {
					return '<div class="colorselect-category" data-id="'+ settings.allCategoriesId +'">'+
								'<div class="colorselect-color-tags">'+
									'<b>Category:</b> '+
                                    '<span>' + (settings.allCategoriesLabel ? $('<div/>').text(settings.allCategoriesLabel).html() : '') + '</span>'+
								'</div>'+
							'</div>';
				},
				selectedCategory: function(category) {
					return '<div class="colorselect-category" data-id="'+ $('<div/>').text(category.id).html() +'" title="'+ $('<div/>').text(category.name).html() +'">'+
								'<div class="colorselect-color-tags">'+
									'<b>Category:</b> '+
                                    '<span>' + (category.name ? $('<div/>').text(category.name).html() : '') + '</span>'+
								'</div>'+
							'</div>';
				},
				selectedColor: function(color) {
					return '<div class="colorselect-color" data-id="'+ color.id +'">'+
								'<div class="colorselect-color-tags">'+
                                '<span>' + (color.tags ? $('<div/>').text(color.tags).html() : '') +'</span>'+
								'</div>'+
								cs.render.paletteColor(color) +
							'</div>';
				},
				paletteColor: function(color) {
					var colorValues, colorString;

					if (color.colorString === 'transparent' || color.a === 0) {
						return '<div class="colorpicker-palette-color color-transparent"'+
									'style="color: transparent" title="transparent" data-id="'+ color.id +'">'+
								'</div>';
					}

					if (color.colorString) {
						colorString = color.colorString;
					} else {
						colorValues = tinycolor({ r: color.r, g: color.g, b: color.b });
						colorString = colorValues.toRgbString();
					}

					return '<div class="colorpicker-palette-color"'+
								'style="color:'+ colorString +'" title="'+ (color.tags ? color.tags : colorString) +'" data-id="'+ color.id +'">'+
							'</div>';
				}
			},


			event: {
				click: {
					document: function(event) {
						if (!$cs.get(0).contains(event.target)) {
							cs.closeCategories();
						}
					},
					categoryMain: function(event) {
						event.stopPropagation();

						if (cs.is.categoriesOpen())
							cs.closeCategories();
						else
							cs.openCategories();
					},
					category: function(event) {
						var selectedCategoryId = $(this).attr('data-id');
						var category = categories.filter(function(c) { return c.id === selectedCategoryId; })[0];

						if (category) {
							STORE.selected.category = category;
							cs.redraw.colors(category.colors);
						} else {
							STORE.selected.category = null;
							cs.redraw.colors();
						}

						if (layout === 'category') {
							$target.val(selectedCategoryId);
						} else {
							cs.setup.selectedColor();
						}

						cs.redraw.categoryMain(category);
						cs.closeCategories();

						$target.trigger(Event.CATEGORYSELECT, category);

						event.stopPropagation();
					},
					color: function(event) {
						var selectedColorId = $(this).attr('data-id');
						var color = colors.filter(function(c) { return c.id === selectedColorId; })[0];
						var category = cs.get.colorCategory(color);

						if (color && category) {
							STORE.selected.category = category;
							$target.val(color.id);
							$target.trigger(Event.CATEGORYSELECT, category);
							$target.trigger(Event.COLORSELECT, color);
							cs.setup.selectedColor();
						}

						cs.closeCategories();

						event.stopPropagation();
					},
					categoryColor: function(event) {
						var selectedColorId = $(this).attr('data-id');
						var color = colors.filter(function(c) { return c.id === selectedColorId; })[0];
						var category = cs.get.colorCategory(color);

						if (color && category) {
							STORE.selected.category = category;

							if (layout === 'category') {
								$target.val(category.id);
								$target.trigger(Event.CATEGORYSELECT, category);
							} else {
								$target.val(color.id);
								$target.trigger(Event.COLORSELECT, color);
								cs.redraw.colors(category.colors);
								cs.setup.selectedColor();
							}
						}

						cs.redraw.categoryMain(category);
						cs.closeCategories();

						event.stopPropagation();
					}
				},

				keyup: {
					colorSearch: function(event) {
						var keyword = $colorSearch.val();

						if (keyword && keyword.length >= settings.minCharacters) {
							cs.search(keyword.toLowerCase());
						} else if (keyword.length === 0) {
							cs.clearSearch();
						}
					},
				}
			},


			bind: {
				standardEvents: function() {
					$categoryMain.bind('click' + EVENTNAMESPACE, cs.event.click.categoryMain);
					$categoryMenu.delegate(selector.category, 'click' + EVENTNAMESPACE, cs.event.click.category);
					$categoryMenu.delegate(selector.paletteColor, 'click' + EVENTNAMESPACE, cs.event.click.categoryColor);
					$colorSearch.bind('keyup' + EVENTNAMESPACE, cs.event.keyup.colorSearch);
					$colorMenu.delegate(selector.color, 'click' + EVENTNAMESPACE, cs.event.click.color);
				},
				documentEvents: function() {
					$(document).bind('click' + EVENTNAMESPACE, cs.event.click.document);
				}
			},

			unbind: {
				documentEvents: function() {
					$(document).unbind('click' + EVENTNAMESPACE);
				},
				standardEvents: function() {
					$categoryMain.unbind('click' + EVENTNAMESPACE);
					$categoryMenu.undelegate('click' + EVENTNAMESPACE);
					$colorSearch.unbind('keyup' + EVENTNAMESPACE);
					$colorMenu.undelegate('click' + EVENTNAMESPACE);
				}
			},

			invoke: function(query, context, methodArguments) {
				var	method, response;
				context = element || context;

				methodArguments = methodArguments || queryArguments;

				if (typeof query == 'string' && instance !== undefined) {
					query = query.split('.');
					$.each(query, function(index, name) {
						if ($.isPlainObject( instance[name])) {
							instance = instance[name];
							return true;
						}
						else if ($.isFunction( instance[name])) {
							method = instance[name];
							return true;
						}
						return false;
					});
				}

				if ($.isFunction(method)) {
					response = method.apply(context, methodArguments);

					if (response !== undefined) {
						returnValue = response;
					}
				}
			}

		};

		if (methodInvoked) {
			if (instance === undefined) {
				cs.initialize();
			}
			cs.invoke(query);
		} else {
			if (instance !== undefined) {
				instance.invoke('destroy');
			}
			cs.initialize();
		}

	});

	return (returnValue !== undefined)
		? returnValue
		: this;
};

var	NAME						= 'DUIColorSelect',
	NAMESPACE					= NAME,
	EVENTNAMESPACE				= '.' + NAMESPACE,

	Event = {
		CATEGORYSELECT			: 'categorySelect' + EVENTNAMESPACE,
		COLORSELECT				: 'colorSelect' + EVENTNAMESPACE
	};

var DEFAULTSETTINGS = {
	allCategories				: true,
	allCategoriesId				: '0',
	allCategoriesLabel			: 'All',
	standardPalette				: false,
	minCharacters				: 1,
	maxCategoryColors			: 8,
	layout						: '',

	selector: {
		target:					'.colorselect-target',
		colorMenu:				'.colorselect-color-menu',
		colorSearch:			'.colorselect-color-search',
		categoryMain:			'.colorselect-category-main',
		categoryMenu:			'.colorselect-category-menu',
		color:					'.colorselect-color',
		category:				'.colorselect-category',
		paletteColor:			'.colorpicker-palette-color'
	},

	className: {
		target:					'colorselect-target',
		active:					'active',
		selected:				'selected'
	},

	templates: {
		container: '<div class="colorselect-container"></div>',
		categorySelect: '<div class="categoryselect">'+
							'<div class="colorselect-main colorselect-category-main"></div>'+
							'<div class="colorselect-menu colorselect-category-menu"></div>'+
						'</div>',
		colorSelect: '<div class="colorselect">'+
						'<input type="text" class="colorselect-search colorselect-color-search">'+
						'<div class="colorselect-menu colorselect-color-menu"></div>'+
					'</div>'
	}
};

$.fn.DUIColorSelect = DUIColorSelect;
$.fn.DUIColorSelect.settings = DEFAULTSETTINGS;

})();

})(jQuery, window, document);


// TinyColor v1.4.1
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
		this._g = color._g;
		this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: Math.round(r * 255), g: Math.round(g * 255), b: Math.round(b * 255) };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: Math.round(r * 255), g: Math.round(g * 255), b: Math.round(b * 255) };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}


    window.tinycolor = tinycolor;


})(Math);
